import React from 'react';
import { FormContainer } from '../../../form/FormContainer';
import FormItem from '../../../form/FormItem';
import ScheduleDateTimeFormWidget from './ScheduleDateTimeFormWidget';
import ScheduleDurationUnitFormWidget from './ScheduleDurationUnitFormWidget';
import ScheduleDurationValueFormWidget from './ScheduleDurationValueFormWidget';
import ScheduleModeFormWidget from './ScheduleModeFormWidget';

export interface ScheduleFormStandardDateOnlyWidgetProps {
    name?: string;
    disabled?: boolean;
}

/**
 * Presentational component for a standard date-focused schedule form layout.
 *
 * Layout structure:
 * - Use Duration toggle
 * - Duration value and unit (side by side)
 * - Start date/time and end date/time (side by side)
 */
export default function ScheduleFormStandardDateOnlyWidget({
    name,
    disabled
}: ScheduleFormStandardDateOnlyWidgetProps) {
    return (
        <>
            <FormContainer>
                <FormItem>
                    <ScheduleModeFormWidget name={name} disabled={disabled} />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <ScheduleDurationValueFormWidget name={name} disabled={disabled} />
                </FormItem>
                <FormItem half>
                    <ScheduleDurationUnitFormWidget name={name} disabled={disabled} />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <ScheduleDateTimeFormWidget variant="start" name={name} disabled={disabled} />
                </FormItem>
                <FormItem half>
                    <ScheduleDateTimeFormWidget variant="end" name={name} disabled={disabled} />
                </FormItem>
            </FormContainer>
        </>
    );
}
